import React from 'react';
var defaultExperienceContextValue = undefined;
export var ExperienceContext = /*#__PURE__*/React.createContext(defaultExperienceContextValue);